import axios from "axios";
import React from "react";
import { Config } from "../../../../../Config";
import AnonymousIcon from "../../../../../Assets/Images/JPA Icons/anonymous.svg";
import { formatDate } from "../../../../../Helper_functions";
import CursorPopup from "../../ShareElements/CursorPopup/CursorPopUp";

const NotificationItem = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleNotificationDate = (ItemDate) => {
    let TodaysDate =
      new Date().getFullYear() +
      "-" +
      new Date().getMonth() +
      "-" +
      new Date().getDate();
    let NotifDate =
      new Date(ItemDate).getFullYear() +
      "-" +
      new Date(ItemDate).getMonth() +
      "-" +
      new Date(ItemDate).getDate();
    if (NotifDate === TodaysDate) {
      return (
        new Date(ItemDate).getHours() + ":" + new Date(ItemDate).getMinutes()
      );
    } else if (ItemDate !== null) {
      return formatDate(new Date(ItemDate));
    }
  };
  const deleteNotification = (Type) => {
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/" +
        Type +
        "/status/" +
        props.NotifItem.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Type === "messages") {
          props.UpdateMessagesList();
        } else {
          props.UpdateEventsList();
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const goToChatRoom = () => {
    let JPAId = props.NotifItem.jpa.id;
    let JPATitle = props.NotifItem.jpa.title;
    let WorkCity = props.NotifItem.jpa.workCity;
    let JPAType = props.NotifItem.type.toLowerCase();
    let RecipientId = props.NotifItem.sender.id;
    let Source = "APPLICATION";
    if (props.NotifItem.source === "HIRING_MANAGER") {
      Source = "CANDIDATE";
    }

    window.localStorage.setItem("chat_jpaId", JPAId);
    window.localStorage.setItem("chat_recipientId", RecipientId);
    window.localStorage.setItem("chat_title", JPATitle);
    window.localStorage.setItem("chat_workCiy", WorkCity);
    window.localStorage.setItem("chat_jpaType", JPAType);
    window.localStorage.setItem("chat_source", Source);

    props.CloseNotifications();
    setTimeout(() => {
      if (window.location.pathname !== "/home/communication") {
        document.getElementById("notif-communication-toggle").click();
      } else {
        // monuts the ICP component again for it to read the new variables
        // set for opening a specific chat item
        props.RemountICP();
      }
    }, 200);
  };

  const goToHomePage = () => {
    document.getElementById("notif-home-toggle")?.click();

    window.localStorage.setItem(
      "notification_jpa_title",
      props.NotifItem.jpa.title
    );
    window.localStorage.setItem("notification_jpa_type", props.NotifItem.type);
    setTimeout(() => {
      if (
        window.location.pathname === "/home/" ||
        window.location.pathname === "/home"
      ) {
        // we're already on the homepage
        if (
          document
            .getElementById("saved-switch-holder")
            .classList.contains("off")
        ) {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          // setting the value of the search input as the title of this notified JPA
          document.getElementById("search-input").value =
            props.NotifItem.jpa.title;
          document.getElementById("search-placeholder").style.display = "none";
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
        } else {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          // setting the value of the search input as the title of this notified JPA
          document.getElementById("saved-switch-holder").classList.add("off");
          setTimeout(() => {
            document.getElementById("search-input").value =
              props.NotifItem.jpa.title;
            document.getElementById("search-placeholder").style.display =
              "none";
            if (document.getElementById("1-page-btn") !== null) {
              document.getElementById("1-page-btn").click();
            }
          }, 200);
        }
        document.getElementById("clear-btn").classList.remove("hidden");
      } else {
        document.getElementById("notif-home-toggle").click();

        setTimeout(() => {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          // setting the value of the search input as the title of this notified JPA
          document.getElementById("search-input").value =
            props.NotifItem.jpa.title;
          document.getElementById("search-placeholder").style.display = "none";
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("clear-btn").classList.remove("hidden");
        }, 1500);
      }
      props.CloseNotifications();
    }, 200);
  };

  const handlePrimaryAction = (Type) => {
    markNotificationAsRead(Type);

    if (Type === "messages") {
      goToChatRoom();
    } else {
      if (props.NotifItem.source === "CANDIDATE") {
        if (props.NotifItem.type === "POSITION") {
          goToHRJPAList("POSITION");
        } else if (props.NotifItem.type === "PROJECT") {
          goToHRJPAList("PROJECT");
        } else if (props.NotifItem.type === "ACTIVITY") {
          goToHRJPAList("ACTIVITY");
        }
      } else if (props.NotifItem.source === "AI_ONLINE_RECOMMENDATION") {
        if (props.NotifItem.type === "POSITION") {
          goToHRCandidateList("POSITION");
        } else if (props.NotifItem.type === "PROJECT") {
          goToHRCandidateList("PROJECT");
        } else if (props.NotifItem.type === "ACTIVITY") {
          goToHRCandidateList("ACTIVITY");
        }
      } else if (props.NotifItem.notifType === "EVENT_COUNTER") {
        handleHomepageFilterRecommendations();
      } else {
        goToHomePage();
      }
    }
  };

  const handleHomepageFilterRecommendations = () => {
    // the required data for search containing counter ids and jpa type
    let SearchData = JSON.stringify({
      counterIds: props.NotifItem.counterIds,
      jpa_type: props.NotifItem.type,
    });
    // encoding as base64 string and saving in localStorage to encode and use where needed
    let EncodedSearchData = Buffer.from(SearchData).toString("base64");
    window.localStorage.setItem(
      "notification_jpa_search_data",
      EncodedSearchData
    );
    var IsMSS = props.IsMSS;
    if (props.IsSuperAdmin) {
      IsMSS = true;
    }

    setTimeout(() => {
      if (
        (window.location.pathname === "/home/" && !IsMSS) ||
        (window.location.pathname === "/home" && !IsMSS) ||
        (window.location.pathname === "/home/ess" && IsMSS) ||
        (window.location.pathname === "/home/ess/" && IsMSS)
      ) {
        // we're already on the homepage
        if (
          document
            .getElementById("saved-switch-holder")
            .classList.contains("off")
        ) {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // Handling the selection of the related jpa recommendation category button

          // JPA recommendation category button IDs
          let CatIDs = ["cat-1", "cat-2", "cat-3"];
          CatIDs.map((Id) => {
            document.getElementById(Id).classList.remove("active-category");
          });
          const addActiveState = (ActiveId) => {
            document.getElementById(ActiveId).classList.add("active-category");
          };
          // activating the related category button
          if (
            !props.NotifItem.counterCategories ||
            props.NotifItem.counterCategories.length > 1
          ) {
            addActiveState("cat-1");
          } else if (props.NotifItem.counterCategories.length === 1) {
            if (props.NotifItem.counterCategories[0] === "EXPLOITATION") {
              addActiveState("cat-2");
            } else if (props.NotifItem.counterCategories[0] === "EXPLORATION") {
              addActiveState("cat-3");
            }
          }

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
        } else {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          document.getElementById("saved-switch-holder").classList.add("off");
          setTimeout(() => {
            if (document.getElementById("1-page-btn") !== null) {
              document.getElementById("1-page-btn").click();
            }
          }, 200);
        }
      } else {
        document.getElementById("notif-home-toggle").click();

        setTimeout(() => {
          //finding the active tab by their className
          let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
          let ActiveTab; // the active tab id
          TabIds.map((Id) => {
            if (document.getElementById(Id).classList.contains("active")) {
              ActiveTab = Id;
            }
          });

          // Handling the selection of the related jpa recommendation category button

          // JPA recommendation category button IDs
          let CatIDs = ["cat-1", "cat-2", "cat-3"];
          CatIDs.map((Id) => {
            document.getElementById(Id).classList.remove("active-category");
          });
          const addActiveState = (ActiveId) => {
            document.getElementById(ActiveId).classList.add("active-category");
          };
          // activating the related category button
          if (
            !props.NotifItem.counterCategories ||
            props.NotifItem.counterCategories.length > 1
          ) {
            addActiveState("cat-1");
          } else if (props.NotifItem.counterCategories.length === 1) {
            if (props.NotifItem.counterCategories[0] === "EXPLOITATION") {
              addActiveState("cat-2");
            } else if (props.NotifItem.counterCategories[0] === "EXPLORATION") {
              addActiveState("cat-3");
            }
          }

          // clicking the tab first, in case the active tab is not a match with the JPA type of this notification item
          if (props.NotifItem.type === "POSITION" && ActiveTab !== "jobs-tab") {
            document.getElementById(TabIds[2]).click();
          } else if (
            props.NotifItem.type === "ACTIVITY" &&
            ActiveTab !== "activities-tab"
          ) {
            document.getElementById(TabIds[1]).click();
          } else if (
            props.NotifItem.type === "PROJECT" &&
            ActiveTab !== "projects-tab"
          ) {
            document.getElementById(TabIds[0]).click();
          }
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
        }, 1500);
      }
      props.CloseNotifications();
    }, 200);
  };

  const removeExtraSpaceChar = (text) => {
    if (
      text !== null &&
      text.length > 0 &&
      text.slice(text.length - 1, text.length) === " "
    ) {
      return text.slice(0, text.length - 1);
    } else {
      return text;
    }
  };

  const goToHRJPAList = (Type) => {
    var Sender = "";
    if (props.NotifItem.revealIdentity) {
      Sender =
        removeExtraSpaceChar(props.NotifItem.sender.firstName) +
        " " +
        removeExtraSpaceChar(props.NotifItem.sender.lastName);
    }
    console.log(Sender);
    var JPAId = props.NotifItem.jpa.id;
    window.localStorage.setItem("JPAItemId", JPAId);
    window.localStorage.setItem("notif_candidate_name", Sender);

    if (Type === "POSITION") {
      if (
        window.location.pathname === "/home/JobDetails" ||
        window.location.pathname === "/home/JobDetails/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-vacancies-toggle").click();
      }
    } else if (Type === "PROJECT") {
      if (
        window.location.pathname === "/home/ProjectDetails" ||
        window.location.pathname === "/home/ProjectDetails/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-projects-toggle").click();
      }
    } else if (Type === "ACTIVITY") {
      if (
        window.location.pathname === "/home/ActivityDetails" ||
        window.location.pathname === "/home/ActivityDetails/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-activities-toggle").click();
      }
    }
    props.CloseNotifications();
  };

  const goToHRCandidateList = (Type) => {
    var Sender =
      removeExtraSpaceChar(props.NotifItem.sender.firstName) +
      " " +
      removeExtraSpaceChar(props.NotifItem.sender.lastName);
    var JPAId = props.NotifItem.jpa.id;
    window.localStorage.setItem("CreatedJPAId", JPAId);
    window.localStorage.setItem("notif_candidate_name", Sender);

    if (Type === "POSITION") {
      if (
        window.location.pathname === "/home/vacancyCandidates" ||
        window.location.pathname === "/home/vacancyCandidates/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-job-candidates-toggle").click();
      }
    } else if (Type === "PROJECT") {
      if (
        window.location.pathname === "/home/projectCandidates" ||
        window.location.pathname === "/home/projectCandidates/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-project-candidates-toggle").click();
      }
    } else if (Type === "ACTIVITY") {
      if (
        window.location.pathname === "/home/activityCandidates" ||
        window.location.pathname === "/home/activityCandidates/"
      ) {
        if (JPAId !== null) {
          document.getElementById("search-input").value = Sender;
          if (document.getElementById("1-page-btn") !== null) {
            document.getElementById("1-page-btn").click();
          }
          document.getElementById("search-placeholder").style.display = "none";
          document.getElementById("clear-btn").classList.remove("hidden");
        }
      } else {
        document.getElementById("notif-activity-candidates-toggle").click();
      }
    }
    props.CloseNotifications();
  };

  const markNotificationAsRead = (Type) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/" +
        Type +
        "/status/" +
        props.NotifItem.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        if (props.UpdateMessagesList) {
          props.UpdateMessagesList();
        } else {
          props.UpdateEventsList();
        }
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const displayNotificationAction = () => {
    let Action = props.NotifItem.currentStage;
    let Source = props.NotifItem.source; // the source of incoming notification
    if (Source === "HIRING_MANAGER") {
      // notification is for a candidate
      if (Action === "REVIEW") {
        return " " + translateText("notif_reviewed_application") + " ";
      } else if (Action === "ACCEPTED") {
        return " " + translateText("notif_accepted_application") + " ";
      } else if (Action === "INTERVIEW") {
        return " " + translateText("notif_changed_to_interview") + " ";
      } else if (Action === "NOT_ACCEPTED") {
        return " " + translateText("notif_rejected_application") + " ";
      } else if (Action === "FINAL_DECISION") {
        return " " + translateText("notif_skipped_interview") + "  ";
      } else if (Action === "RESET") {
        return " " + translateText("notfi_reset_application") + " ";
      }
    } else {
      // notification is for a manager
      if (Source === "AI_ONLINE_RECOMMENDATION") {
        return (
          " " +
          translateText("notfi_candidate_has_been_recommended") +
          " " +
          displayAIRecomJPAType(props.NotifItem.type).toLocaleLowerCase()
        );
      } else {
        if (Action === "APPLIED") {
          return " " + translateText("notfi_applied_for") + " ";
        } else if (Action === "INTERVIEW") {
          return " " + translateText("notif_accepted_interview") + " ";
        } else if (Action === "CANCELLED") {
          return " " + translateText("notif_cancelled_interview") + " ";
        }
      }
    }
  };

  const displayAIRecomJPAType = (Type) => {
    if (Type === "POSITION") {
      return translateText("job");
    } else if (Type === "PROJECT") {
      return translateText("project");
    } else if (Type === "ACTIVITY") {
      return translateText("activity");
    }
  };

  const displayAIRecomIconContent = (Type) => {
    if (Type === "POSITION") {
      return "J.";
    } else if (Type === "PROJECT") {
      return "P.";
    } else if (Type === "ACTIVITY") {
      return "A.";
    }
  };

  const shortenWorkCity = (WorkCities) => {
    let Cities = WorkCities;

    if (!WorkCities) {
      return translateText("not_available");
    } else {
      if (Cities.length <= 25) {
        return WorkCities;
      } else {
        let Shortened = Cities.slice(0, 22) + " ...";
        return (
          <React.Fragment>
            {String(Shortened)}
            <p className="popup-text">{String(Cities)}</p>
          </React.Fragment>
        );
      }
    }
  };

  return (
    <section
      className={
        props.IsRead
          ? "notification-item"
          : "notification-item notification-item-unread"
      }
      onClick={
        props.IsEvent
          ? () => markNotificationAsRead("events")
          : () => markNotificationAsRead("messages")
      }
    >
      {props.IsEvent ? (
        <React.Fragment>
          {props.NotifItem.source === "AI_OFFLINE_RECOMMENDATION" &&
          props.NotifItem.sender === null ? (
            <React.Fragment>
              {props.NotifItem.notifType === "EVENT_COUNTER" ? (
                <React.Fragment>
                  <div className="notification-icon">
                    <div className="round-icon jpa-recommendation-icon">
                      {displayAIRecomIconContent(props.NotifItem.type)}
                    </div>
                  </div>
                  <div className="notification-content">
                    <section className="notif-text-content">
                      <React.Fragment>
                        <p className="recom-notif-text">
                          {translateText("there_are") +
                            " " +
                            props.NotifItem.counter +
                            " " +
                            translateText("new") +
                            " " +
                            displayAIRecomJPAType(props.NotifItem.type) +
                            " " +
                            translateText("recommendations") +
                            " "}
                        </p>
                      </React.Fragment>
                      {displayNotificationAction()}
                    </section>
                    <section className="notif-info info-grid">
                      <span className="info-item date-info">
                        {handleNotificationDate(
                          props.NotifItem.notificationTime
                        )}
                      </span>
                    </section>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="notification-icon">
                    <div className="round-icon jpa-recommendation-icon">
                      {displayAIRecomIconContent(props.NotifItem.type)}
                    </div>
                  </div>
                  <div className="notification-content">
                    <section className="notif-text-content">
                      {" "}
                      <strong>
                        <React.Fragment>
                          <p className="recom-notif-text">
                            {"New " +
                              displayAIRecomJPAType(props.NotifItem.type) +
                              " recommendation "}
                          </p>
                        </React.Fragment>
                      </strong>{" "}
                      {displayNotificationAction()}
                      <strong>{props.NotifItem.jpa.title}</strong>
                    </section>
                    <section className="notif-info info-grid">
                      <span
                        className={
                          props.IsRead
                            ? "info-item read-ai-recommendation-workcity"
                            : "info-item"
                        }
                      >
                        <i className="feather-map-pin"></i>
                        {shortenWorkCity(props.NotifItem.jpa.workCity)}
                      </span>
                      <span className="info-item date-info">
                        {handleNotificationDate(
                          props.NotifItem.notificationTime
                        )}
                      </span>
                    </section>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="notification-icon">
                {!props.NotifItem.revealIdentity &&
                props.NotifItem.source === "CANDIDATE" ? (
                  <div className="round-icon anonymous-icon">
                    <img alt="" src={AnonymousIcon} />
                  </div>
                ) : (
                  <React.Fragment>
                    {props.NotifItem.sender.imageThumbnailUrl === null ? (
                      <div
                        className="round-icon"
                        style={{
                          backgroundColor:
                            props.NotifItem.sender.backgroundColorCode,
                          color: props.NotifItem.sender.textColorCode,
                        }}
                      >
                        {props.NotifItem.sender.firstName
                          .slice(0, 1)
                          .toUpperCase() +
                          props.NotifItem.sender.lastName
                            .slice(0, 1)
                            .toUpperCase()}
                      </div>
                    ) : (
                      <img
                        alt=""
                        src={props.NotifItem.sender.imageThumbnailUrl}
                        className="user-avatar"
                      />
                    )}
                  </React.Fragment>
                )}
              </div>
              <div className="notification-content">
                <section className="notif-text-content">
                  {" "}
                  <strong>
                    {!props.NotifItem.revealIdentity &&
                    props.NotifItem.source === "CANDIDATE" ? (
                      "Unknown"
                    ) : (
                      <React.Fragment>
                        {props.NotifItem.sender.firstName +
                          " " +
                          props.NotifItem.sender.lastName}
                      </React.Fragment>
                    )}
                  </strong>{" "}
                  {displayNotificationAction()}
                  <strong>{props.NotifItem.jpa.title}</strong>
                </section>
                <section className="notif-info info-grid">
                  <span className="info-item">
                    <i className="feather-map-pin"></i>
                    {shortenWorkCity(props.NotifItem.jpa.workCity)}
                  </span>
                  <span className="info-item date-info">
                    {handleNotificationDate(props.NotifItem.notificationTime)}
                  </span>
                </section>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="notification-icon">
            {props.NotifItem.sender.imageThumbnailUrl === null ? (
              <div
                className="round-icon"
                style={{
                  backgroundColor: props.NotifItem.sender.backgroundColorCode,
                  color: props.NotifItem.sender.textColorCode,
                }}
              >
                {props.NotifItem.sender.firstName.slice(0, 1).toUpperCase() +
                  props.NotifItem.sender.lastName.slice(0, 1).toUpperCase()}
              </div>
            ) : (
              <img
                alt=""
                src={props.NotifItem.sender.imageThumbnailUrl}
                className="user-avatar"
              />
            )}
          </div>
          <div className="notification-content">
            <section className="notif-text-content">
              {translateText("notfi_new_message")}{" "}
              <strong>
                {props.NotifItem.sender.firstName +
                  " " +
                  props.NotifItem.sender.lastName}
              </strong>{" "}
              regarding
              <strong>{" " + props.NotifItem.jpa.title + " "}</strong>
              <span className="info-item">
                <i className="feather-map-pin"></i>
                {shortenWorkCity(props.NotifItem.jpa.workCity)}
              </span>
            </section>
            <section className="notif-info info-grid">
              <span className="info-item date-info is-desktop">
                {handleNotificationDate(props.NotifItem.notificationTime)}
              </span>
            </section>
          </div>
          <span className="info-item date-info is-mobile">
            {handleNotificationDate(props.NotifItem.notificationTime)}
          </span>
        </React.Fragment>
      )}
      <div className="notification-actions">
        {props.IsEvent ? (
          <div
            className="notif-action delete-action"
            onClick={() => deleteNotification("events")}
          >
            <i className="feather-trash-2"></i>
          </div>
        ) : (
          <div
            className="notif-action delete-action"
            onClick={() => deleteNotification("messages")}
          >
            <i className="feather-trash-2"></i>
          </div>
        )}
        {props.IsEvent ? (
          <div
            className="notif-action primary-action"
            onClick={() => handlePrimaryAction("events")}
          >
            <i className="feather-arrow-right"></i>
          </div>
        ) : (
          <div
            className="notif-action primary-action"
            onClick={() => handlePrimaryAction("messages")}
          >
            <i className="feather-arrow-right"></i>
          </div>
        )}
      </div>
    </section>
  );
};

export default NotificationItem;
